import type { QueryClient } from '@tanstack/react-query';
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';
import type { ReactElement } from 'react';

import { DarkModeSwitcher } from 'shared/modules/theme';

/**
 * The RouterContext defines values provided to every route
 * through TanStack Router's context mechanism. This ensures all routes
 * have access to shared dependencies (such as user, customer, subscription and feature allowance data).
 */
export interface RouterContext {
  queryClient: QueryClient;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent
});

function RootComponent(): ReactElement {
  return (
    <div>
      <div role="navigation" />
      <Outlet />
      <DarkModeSwitcher />
      <TanStackRouterDevtools />
    </div>
  );
}
